// ** React Imports
import { useState, Fragment } from "react";

// ** Next Import
// import { useRouter } from "next/router";

// ** MUI Imports
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button, Grid, IconButton, Modal } from "@mui/material";
import { Close, Logout } from "@mui/icons-material";
import { getEmail } from "../../utils/storage";
import { useSelector } from "react-redux";
import PersonIcon from "@mui/icons-material/Person";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

const UserDropdown = ({ handleLogout, Evaluate_user, isLoggedIn, superAdmin }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  const IncognitoModeStatus = useSelector(
    (state) => state.IncognitoMode?.IncognitoUser || false
  );
  const uuid = useSelector(
    (state) => state?.userReducer?.uuid || sessionStorage.getItem("uuid")
  );
  const viewAsRecruiter = useSelector(
    (state) => state.userReducer.viewAsRecruiter
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = (url) => {
    if (url) {
      navigate(url);
    }
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openLogout, setOpenLogout] = useState(null);

  const handleModal = () => {
    setOpenLogout(true);
    setAnchorEl(null);
  };
  const handleCloseModal = () => {
    setOpenLogout(false);
    setAnchorEl(null);
  };

  const MenuItemStyled = styled(MenuItem)(() => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    color: "inherit",
    "& svg": {
      fontSize: "25px",
    },
    "&:hover ,&:hover svg": {
      color: `rgba(38,138,30) !important`,
    },
  }));

  return (
    <Fragment>
      <Button
        onClick={handleClick}
        size="small"
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableRipple
        endIcon={<ArrowDropDownIcon sx={{ color: "#FDF9E0" }} />}
        sx={{
          display: { xs: "none", md: "flex", lg: "flex" },
          minWidth: "unset",
          padding: "0px",
          ml: 2,
          "& .MuiMenu-paper": { width: 230, mt: 4.75 },
          "&:hover": {
            background: "none",
          },
        }}
      >
                 <Avatar
           alt={`${getEmail().toUpperCase()}`}
           sx={{
             width: 38,
             height: 38,
             bgcolor: "#FDF9E0",
             color: "#000",
             ...(superAdmin && {
               border: "2px solid #26801E",
               boxShadow: "0 0 8px rgba(38, 128, 30, 0.3)"
             })
           }}
           slotProps={{
             img: {
               loading: "lazy",
             },
           }}
         >
           {getEmail().charAt(0).toUpperCase()}
         </Avatar>
      </Button>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "#FDF9E0",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
            color: "#000 !important",
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleClose}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Badge
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
                       <Avatar
           alt={`${getEmail().toUpperCase()}`}
           sx={{ 
             width: "2.5rem", 
             height: "2.5rem", 
             mr: 1,
             ...(superAdmin && {
               border: "2px solid #26801E",
               boxShadow: "0 0 8px rgba(38, 128, 30, 0.3)"
             })
           }}
           slotProps={{
             img: {
               loading: "lazy",
             },
           }}
         >
           {getEmail().charAt(0).toUpperCase()}
         </Avatar>
            </Badge>
                         <Box
               sx={{
                 display: "flex",
                 alignItems: "flex-start",
                 flexDirection: "column",
               }}
             >
               <Typography variant="body2">{getEmail()}</Typography>
               {superAdmin && (
                 <Typography 
                   variant="caption" 
                   sx={{ 
                     color: "#26801E", 
                     fontWeight: 600,
                     fontSize: "0.75rem"
                   }}
                 >
                   Super Admin
                 </Typography>
               )}
             </Box>
          </Box>
        </MenuItem>
        <Divider />

        {uuid && uuid !== "null" && viewAsRecruiter === false && (
          <MenuItemStyled
            onClick={() => navigate(`/profile/${uuid}`)}
            rel="noopener noreferrer"
          >
            <PersonIcon />
            Profile
          </MenuItemStyled>
        )}

        <MenuItemStyled
          onClick={() => navigate("/resume-history")}
          rel="noopener noreferrer"
        >
          <HistoryIcon />
          Resume History
        </MenuItemStyled>
        {viewAsRecruiter && (
          <MenuItemStyled
            onClick={() => navigate("/advanced-data-search")}
            rel="noopener noreferrer"
          >
            <SearchIcon />
            Advanced Data Search
          </MenuItemStyled>
        )}
        {viewAsRecruiter && (
          <MenuItemStyled
            onClick={() => navigate("/advanced-jd-search")}
            rel="noopener noreferrer"
          >
            <FindInPageIcon />
            JD Ranker
          </MenuItemStyled>
        )}
        {viewAsRecruiter && (
          <MenuItemStyled
            onClick={() => navigate("/resume-ranker")}
            rel="noopener noreferrer"
          >
            <DocumentScannerIcon />
            Resume Ranker (File Based)
          </MenuItemStyled>
        )}
        {viewAsRecruiter && (
          <MenuItemStyled
            onClick={() => navigate("/pending-resumes")}
            rel="noopener noreferrer"
          >
            <PendingActionsIcon />
            Pending Resumes
          </MenuItemStyled>
        )}
        {location.pathname !== "/Upload-Resume" && (
          <MenuItemStyled
            onClick={() => navigate("/Upload-Resume")}
            rel="noopener noreferrer"
          >
            <UploadFileIcon />
            Upload Resume
          </MenuItemStyled>
        )}
        <Divider />
        <MenuItemStyled onClick={handleModal}>
          <Logout />
          Logout
        </MenuItemStyled>
      </Menu>
      <Modal
        open={openLogout}
        // onClose={handleClose}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "#FDF9E0",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography
              id="logout-modal-title"
              variant="h6"
              component="h2"
              sx={{ fontWeight: 600 }}
            >
              Confirm Logout
            </Typography>
            <IconButton onClick={handleCloseModal}>
              <Close />
            </IconButton>
          </Grid>
          <Typography
            id="logout-modal-description"
            sx={{ mt: 2, fontWeight: 600 }}
          >
            Are you sure you want to logout?
          </Typography>
          <Grid container justifyContent="space-between" sx={{ mt: 4 }}>
            <Button
              sx={{ borderRadius: "55px", fontSize: "16px", fontWeight: 600 }}
              onClick={() => {
                handleLogout();
                setOpenLogout(false);
              }}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
            <Button
              sx={{ borderRadius: "55px", fontSize: "16px", fontWeight: 600 }}
              onClick={handleCloseModal}
              color="#000"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Box>
      </Modal>
    </Fragment>
  );
};

export default UserDropdown;
